export const environmentKeys = JSON.parse(process.env.ENVIRONMENTS ?? "{}");
export const accessControlEnvironment = process.env.ACCESS_CONTROL_ENVIRONMENT;
export const accessControlEnvironmentKey = environmentKeys[accessControlEnvironment];
